import { LanguageChoice } from "@/components/language-choice";
import { Head, usePage } from "@inertiajs/react";
import { FormErrors } from "@/components/forms/form-errors";
import { ReactNode } from "react";

export default function AuthLayout({
  children,
  title,
  description,
  headingInContent = false,
}: {
  children: ReactNode;
  title: string;
  description: string;
  headingInContent?: boolean;
}) {
  const { flash } = usePage<{ flash?: { alert?: string; notice?: string } }>()
    .props;
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="bg-canvas flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10"
    >
      <Head title={title} />
      <div className="w-full max-w-md rounded-lg border bg-card p-6 sm:p-8">
        <div className="mb-6">
          <LanguageChoice />
        </div>
        {!headingInContent && (
          <header className="mb-6 space-y-2">
            <h1 className="text-page font-display">{title}</h1>
            <p className="text-muted-foreground text-sm">{description}</p>
          </header>
        )}
        {flash?.alert && (
          <div className="mb-6">
            <FormErrors errors={{ base: flash.alert }} />
          </div>
        )}
        {flash?.notice && (
          <p role="status" className="mb-6 rounded-lg border p-4 text-sm">
            {flash.notice}
          </p>
        )}
        {children}
      </div>
    </main>
  );
}
